import { TYPE_NUMBER } from './input-types';

export const id = 'zone';
export const apiKey = 'Zone';
export const type = TYPE_NUMBER;

export const zone = {
  id,
  apiKey,
  type,
};
